export default {
  searchRecieveCredit: {
    search: {
      companyCode: '公司',
      companyCodePlaceholder: '请选择公司',
      departmentCodes: '部门',
      departmentCodesPlaceholder: '请选择部门',
      clCode: '信用证号',
      clCodePlaceholder: '请输入信用证号',
      issueDateStart: '开证日期从',
      issueDateStartPlaceholder: '请选择开始日期',
      issueDateEnd: '开证日期到',
      issueDateEndPlaceholder: '请选择结束日期',
      partnerCodes: '开证申请人',
      partnerCodesPlaceholder: '请选择开证申请人（多个）',
      createBy: '创建人',
      createByPlaceholder: '请输入创建人',
      clType: '信用证类别',
      clTypePlaceholder: '请选择信用证类别',
      clValidDateStart: '有效期限从',
      clValidDateStartPlaceholder: '请选择开始日期',
      clValidDateEnd: '有效期限到',
      clValidDateEndPlaceholder: '请选择结束日期',
      clNature: '信用证性质',
      clNaturePlaceholder: '请选择信用证性质',
      bankId: '开证银行',
      bankIdPlaceholder: '请选择开证银行',
      currencyCode: '币别',
      currencyCodePlaceholder: '请选择币别',
      acceptDateStart: '承兑日期从',
      acceptDateStartPlaceholder: '请选择开始日期',
      acceptDateEnd: '承兑日期到',
      acceptDateEndPlaceholder: '请选择结束日期',
      statusFlag: '信用证状态',
      statusFlagPlaceholder: '请选择信用证状态',
      accStatusFlag: '承兑状态',
      accStatusFlagPlaceholder: '请选择承兑状态',
      payBranchCode: '收款银行账户名称',
      payBranchCodePlaceholder: '请选择收款银行账户名称',
      planPayDateStart: '计划收款日期从',
      planPayDateStartPlaceholder: '请选择开始日期',
      planPayDateEnd: '计划收款日期到',
      planPayDateEndPlaceholder: '请选择结束日期',
      isAccpetComplete: '是完全承兑',
      isPayComplete: '是完全付款',
      clAmount: '信用证金额',
      delayPaymentType1: '部门不押汇公司押汇',
      delayPaymentType2: '部门押汇公司不押汇',
      delayPaymentType3: '部门押汇且公司押汇',
      acceptAmount: '承兑金额',
      accIsLockExchangeRate: '是押汇锁汇',
      isLockExchangeRate: '是承兑锁汇',
    },
    table: {
      companyName: '公司',
      departmentName: '部门',
      clCode: '信用证号',
      clType: '信用证类别',
      clAmount: '信用证金额',
      currencyName: '币别',
      bankBranch: '开证银行',
      issueDate: '开证日期',
      clNature: '信用证性质',
      partnerName: '开证申请人',
      clValidDate: '有效期限',
      acceptanceAmount: '已承兑金额',
      paidAmount: '已收款金额',
      isAccpetComplete: '是否完全承兑',
      isPayComplete: '是否完全收款',
      statusFlag: '信用证状态',
      createBy: '创建人',
      gmtCreate: '创建日期',
    },
    msg: {
      validDate: '有效期开始时间不能大于有效期截止时间',
      overlayDate: '有效期重叠，不可新增',
    },
    btnList: {
      add: '新增',
      del: '删除',
      save: '保存',
    },
    tips: {
      noSelectData: '请至少选择一条数据进行操作',
      onlyOneSelectData: '请选择一条数据进行操作',
      noExport: '当前没有数据可以导出！',
      noDelect: '只有已登记数据可以删除，请重新选择！',
      noRegister: '只有已保存数据可以登记，请重新选择！',
      noClaim: '只有已登记数据可以认领，请重新选择！',
      noAccept: '只有已认领数据可以承兑，请重新选择！',
      noCanDelSelectData: '所选数据中没有已保存和已登记状态，请重新选择！',
      hasCannotDelTip: '所选数据中有不可删除的数据，点击确认只会删除已保存和已登记状态的数据！',
    },
  },
};
